<template>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle :title="`Kartu Stok: ${this.item.code} - ${this.item.name}`" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg"
      >
        <div v-if="loading" class="flex justify-center items-center h-32">
          <div
            class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"
          ></div>
        </div>
        <div v-else>
          <TableComponent>
            <TableHead>
              <TableRow>
                <TableHeadCell>No</TableHeadCell>
                <TableHeadCell>Tanggal</TableHeadCell>
                <TableHeadCell>Saldo Awal</TableHeadCell>
                <TableHeadCell>In</TableHeadCell>
                <TableHeadCell>Out</TableHeadCell>
                <TableHeadCell>Saldo Akhir</TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow v-for="(stockMovement, index) in stockMovements" :key="stockMovement.id">
                <TableCell>{{ index + 1 }}</TableCell>
                <TableCell>{{ formatTime(stockMovement.createdAt) }}</TableCell>
                <TableCell>{{ stockMovement.opening_balance }}</TableCell>
                <TableCell>{{ stockMovement.qty_in }}</TableCell>
                <TableCell>{{ stockMovement.qty_out }}</TableCell>
                <TableCell>{{ stockMovement.closing_balance }}</TableCell>
              </TableRow>
            </TableBody>
          </TableComponent>
          <PaginationButtons
            v-model="currentPage"
            :totalPages="totalPages"
          />
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import TableComponent from "@/components/table/Table.vue";
import TableHead from "@/components/table/TableHead.vue";
import TableBody from "@/components/table/TableBody.vue";
import TableRow from "@/components/table/TableRow.vue";
import TableCell from "@/components/table/TableCell.vue";
import TableHeadCell from "@/components/table/TableHeadCell.vue";
import { formatTime } from "@/helpers/formatTime";
import { formatRupiah } from "@/helpers/formatRupiah";
import { mapGetters } from "vuex";
import ViewContainer from "@/components/ViewContainer.vue";
import PaginationButtons from "@/components/PaginationButtons.vue";

export default {
  name: "StockMovement",
  components: {
    IndexView,
    ViewContainer,
    PageTitle,
    TableComponent,
    TableHead,
    TableHeadCell,
    TableBody,
    TableRow,
    TableCell,
    PaginationButtons,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      stockMovements: [],
      currentPage: 1,
      totalPages: 1,
      item: {},
    };
  },
  computed: {
    ...mapGetters("stock_movements", ["allStockMovements"]),
  },
  async created() {
    this.fetchSpecifiedItem();
    this.fetchStockMovements();
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchStockMovements({ page: newVal });
      },
    },
  },
  methods: {
    formatTime,
    formatRupiah,
    async fetchSpecifiedItem() {
      const response = await this.$store.dispatch('items/fetchItemById', this.$route.params.id);
      this.item = response.data;
    },
    async fetchStockMovements(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { data, pagination } = await this.$store.dispatch(
          "stock_movements/fetchStockMovements",
          {
            ...params,
            item_id: this.$route.params.id,
          }
        );
        this.stockMovements = data;
        this.totalPages = pagination.totalPages;
      } catch (error) {
        console.error("Error fetching stock movements:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
